import {SvgIcon} from "@material-ui/core";
import ApartmentIcon from "@material-ui/icons/Apartment";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import React from "react";

export const accessDeviceTypes = {
    'BARCODE': {
        text: 'Barcode / QR CODE',
        icon: <SvgIcon fontSize="large" viewBox="0 0 37.084 29.667">
            <path
                d="M3.09 3.708h1.236v20.396H3.09zm3.091 0h1.854v20.396H6.181zm3.708 0h1.236v20.396H9.889zm2.473 0h1.275v20.396h-1.275zm3.09 0h1.236v20.396h-1.236zM.618 0A.584.584 0 0 0 0 .618v3.09h1.236V1.236h2.472V0zm17.306 3.708h1.236v20.396h-1.236zm5.563 0h1.854v20.396h-1.854zm2.586 0h.671v20.396h-.671zm-6.293 0h.671v20.396h-.671zm-5.769 0h.671v20.396h-.671zm-2.362 0h.411v20.396h-.411zm-3.146 0h.618v20.396h-.618zm-3.671 0h.618v20.396h-.618zm22.363 0h1.236v20.396h-1.236zm2.473 0h1.854v20.396h-1.854zm3.09 0h1.236v20.396h-1.236zM1.236 28.431v-2.472H0v3.09a.584.584 0 0 0 .618.618h3.09v-1.236zm34.612-2.472v2.472h-2.472v1.236h3.09a.584.584 0 0 0 .618-.618v-3.09zM36.466 0h-3.09v1.236h2.472v2.472h1.236V.618A.584.584 0 0 0 36.466 0zM21.015 3.708h1.236v20.396h-1.236z"/>
        </SvgIcon>,

    },
    'PROXIMITY_CARD': {
        text: 'Proximity Card',
        icon: <SvgIcon fontSize="large" viewBox="0 0 31 55">
            <path
                d="M22.927 44H8.078C7.482 44 7 44.446 7 44.999 7 45.55 7.482 46 8.078 46h14.848c.592 0 1.074-.45 1.074-1.001 0-.553-.482-.999-1.073-.999z"/>
            <path
                d="M27.644 0c-.006 0-.01 0-.016.003H15.524a.144.144 0 0 0-.05 0h-12.1C3.366 0 3.36 0 3.354 0 1.504 0 0 1.386 0 3.09v48.822C0 53.616 1.504 55 3.354 55h24.29C29.494 55 31 53.616 31 51.912V3.09C31 1.386 29.495 0 27.644 0zm.095 52.885H3.258c-.605-.006-1.095-.457-1.095-1.013V3.127c0-.554.49-1.006 1.095-1.012H27.74c.605.006 1.097.457 1.097 1.012v48.745c0 .555-.493 1.007-1.098 1.013z"/>
        </SvgIcon>,
    },
    'TENANT_ACCESS_CARD': {
        text: 'Tenant Access Card',
        icon: <ApartmentIcon fontSize="large"/>,
    },
    'AVI_TRANSPONDER': {
        text: 'AVI Transponder',
        icon: <SvgIcon fontSize="large" viewBox="0 0 56 32">
            <path d="M54,2V30H2V2H54m0-2H2A2,2,0,0,0,0,2V30a2,2,0,0,0,2,2H54a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2Z"/>
            <path d="M48.5,23h-14a1,1,0,0,0,0,2h14a1,1,0,0,0,0-2Z"/>
        </SvgIcon>,

    },
    'WINDSHIELD_STICKER': {
        text: 'Windshield Sticker',
        icon: <SvgIcon fontSize="large" viewBox="0 0 54 54">
            <path
                d="M19.6 33.8h-5.2c-1.8 0-3.4-.7-4.6-2-1-1.1-1.5-2.5-1.5-4V10.7c0-1.3 1-2.3 2.3-2.3h32.6c1.2 0 2.1.8 2.3 1.9v33c0 1.4-1 2.3-2.3 2.3H25.6c-2.1 0-3.8-.8-5.1-2.6-.7-1.1-1.1-2.2-1.1-3.5V34c.2 0 .2-.1.2-.2zm23.8 9.6V10.6H10.6v17.1c0 .4 0 .8.2 1.1.5 1.6 1.9 2.6 3.5 2.6h7.5v8.1c0 .6.1 1.1.3 1.7.7 1.4 1.9 2.2 3.5 2.2h17.8z"/>
            <path d="M10.7 38.2V36h6.7v6.7h-2.2v-2.8C14 41 12.9 42 11.9 43.1l-1.6-1.6 3.2-3.2v-.1h-2.8z"/>
        </SvgIcon>,
    },
    'LICENSE_PLATE_RECOGNITION': {
        text: 'License Plate Recognition',
        icon: <SvgIcon fontSize="large" viewBox="0 0 56 32">
            <path d="M54,2V30H2V2H54m0-2H2A2,2,0,0,0,0,2V30a2,2,0,0,0,2,2H54a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2Z"/>
            <path d="M7.5,6a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"/>
            <path d="M7.5,22a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"/>
            <path d="M47.5,6a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"/>
            <path d="M47.5,22a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"/>
        </SvgIcon>,
    },
    'FLASH_PARKING_APP': {
        text: 'Flash Parking App',
        icon: <SmartphoneIcon fontSize="large"/>,
    },
    'HANG_TAG': {
        text: 'Hang Tag',
        icon: <SvgIcon fontSize="large" viewBox="0 0 30 30">
            <g>
                <path d="M16,1A7.0081,7.0081,0,0,0,9,8a1,1,0,0,0,2,0,5,5,0,1,1,5,5H12a3.0033,3.0033,0,0,0-3,3V28a3.0033,3.0033,0,0,0,3,3h8a3.0033,3.0033,0,0,0,3-3V8A7.0081,7.0081,0,0,0,16,1Zm5,27a1.0009,1.0009,0,0,1-1,1H12a1.0009,1.0009,0,0,1-1-1V16a1.0009,1.0009,0,0,1,1-1h4a6.98,6.98,0,0,0,5-2.1055Z">
                </path>
                <path d="M13,22a1,1,0,0,0,1,1h4a1,1,0,0,0,0-2H14A1,1,0,0,0,13,22Z">
                </path>
                <path d="M18,25H14a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z">
                </path>
            </g>
        </SvgIcon>
    }
}

accessDeviceTypes.Barcode = accessDeviceTypes.BARCODE;
accessDeviceTypes['Proximity Card'] = accessDeviceTypes.PROXIMITY_CARD;
accessDeviceTypes['Tenant Access Card'] = accessDeviceTypes.TENANT_ACCESS_CARD;
accessDeviceTypes['AVI Transponder'] = accessDeviceTypes.AVI_TRANSPONDER;
accessDeviceTypes['Windshield Sticker'] = accessDeviceTypes.WINDSHIELD_STICKER;
accessDeviceTypes['License Plate Recognition'] = accessDeviceTypes.LICENSE_PLATE_RECOGNITION;
accessDeviceTypes['Flash Parking App'] = accessDeviceTypes.FLASH_PARKING_APP;
accessDeviceTypes['Hang Tag'] = accessDeviceTypes.HANG_TAG;

export default accessDeviceTypes;
